var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91.767,
    height: 42.66,
    viewBox: "0 0 91.767 42.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.767,
    height: 42.66,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.009,2.836a17.894,17.894,0,0,0-19.335,0,9.238,9.238,0,0,0-4.34,7.527,9.238,9.238,0,0,0,4.34,7.528A16.045,16.045,0,0,0,86.5,20.516l-.024,0L98.971,24.2l-3.18-4.619a14.7,14.7,0,0,0,3.218-1.69,9.238,9.238,0,0,0,4.339-7.528,9.238,9.238,0,0,0-4.339-7.527M84.1,17.2a9.727,9.727,0,0,1-4.861-3.673,4.544,4.544,0,0,1,1.623-1.735l.3-.163-.3-.15a2.518,2.518,0,1,1,2.241,0l-.3.15.3.163a4.592,4.592,0,0,1,1.653,1.786A15.962,15.962,0,0,0,84.1,17.2m5.245.924a15.032,15.032,0,0,1-4.59-.7c.207-3.623,1.543-6.71,3.346-7.707l.3-.163-.3-.15a2.8,2.8,0,1,1,2.49,0l-.3.15.3.163c1.8,1,3.14,4.085,3.346,7.71a15.049,15.049,0,0,1-4.579.693m5.236-.921a15.918,15.918,0,0,0-.649-3.613,4.6,4.6,0,0,1,1.659-1.8l.3-.163-.3-.15a2.518,2.518,0,1,1,2.241,0l-.3.15.3.163a4.55,4.55,0,0,1,1.628,1.742A9.74,9.74,0,0,1,94.577,17.2",
    transform: "translate(-55.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.988,116.12C5.925,116.12,0,113.992,0,108c0-6.36,6.978-8.122,11.988-8.122a22.514,22.514,0,0,1,9.655,1.808l-1.03,3.706a20.931,20.931,0,0,0-8.145-1.624c-4.69,0-7,1.647-7,4.256,0,2.562,2.471,4.21,6.978,4.233a20.382,20.382,0,0,0,8.168-1.624l1.052,3.684a24.663,24.663,0,0,1-9.678,1.807",
    transform: "translate(0 -73.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,116.12c-5.628,0-11.668-2.2-11.668-8.122,0-5.9,5.994-8.122,11.668-8.122,5.7,0,11.691,2.219,11.691,8.122,0,5.926-5.926,8.122-11.691,8.122m0-12.56c-3.844,0-6.063,1.693-6.063,4.438s2.219,4.439,6.063,4.439c3.866,0,6.086-1.67,6.086-4.439,0-2.745-2.219-4.438-6.086-4.438",
    transform: "translate(-61.588 -73.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.02,112.667h-9.243v4.187h-5.285v-15.42H194c3.615,0,6.337,1.785,6.337,5.537,0,3.638-2.723,5.7-6.314,5.7m-1.441-7.6h-7.8v3.958h7.939a2.019,2.019,0,0,0,2.2-2.059c0-1.258-.984-1.9-2.334-1.9",
    transform: "translate(-132.018 -74.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.395,116.535l-1.464-2.448H255.7l-1.487,2.448h-6.475L258.175,101h5.4l10.41,15.535Zm-6.566-11.1-3,5.01H263.8Z",
    transform: "translate(-182.217 -74.287)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopaLogo);
export default __webpack_public_path__ + "static/media/COPALogo.40522495f32a320d72cccf96e65bc837.svg";
export { ForwardRef as ReactComponent };